var _effectorFileName = "/src/page-content/login/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const loginPage = declarePage({
  pageType: pagesPath.$url().pathname
});